<template>
<div class="" id="" style="">
	<header-vue></header-vue>
   <div class="container-l2">
			<h1 class="h11">告警统计</h1>
			<div class="text-center">
				<el-select class="select1" @change="clickCom()" value-key="uid" v-if="administrators!=1 && administrators!=2" v-model="selectComId" placeholder="请选择公司">
					<el-option label="所有公司" key="-1" value=""></el-option>
		          <el-option v-for="com in comList" :label="com.company" :key="com.uid" :value="com.company_id"></el-option>
		        </el-select>
		        <el-select class="select1" v-model="selectAreaId" placeholder="请选择区域">
		          <el-option v-for="(area,index) in areaList" :label="area.group_name" :key="index" :value="area.packet_id"></el-option>
		        </el-select>
		        <el-select class="select1" v-model="alarm_device_type" placeholder="请选择设备类别">
		        	<el-option label="所有" key="-1" value=""></el-option>
		          <el-option v-for="(type,index) in typelist" :label="type.alarm_device_name" :key="index" :value="type.id"></el-option>
		        </el-select>
		        <el-select class="select1" v-model="alarm_type" placeholder="请选择告警类别">
		        	<el-option label="所有" key="-1" value="-1"></el-option>
		        	<el-option label="红色告警" key="1" value="1"></el-option>
		        	<el-option label="橙色告警" key="2" value="2"></el-option>
		        	<el-option label="告警解除" key="3" value="3"></el-option>
		        </el-select>
				<el-date-picker
			      v-model="startdate"
			      type="date"
			      value-format="yyyy-MM-dd"
			      placeholder="开始日期">
			    </el-date-picker>
			    <el-date-picker
			      v-model="enddate"
			      type="date"
			      value-format="yyyy-MM-dd"
			      placeholder="结束日期">
			    </el-date-picker>
			    <el-button @click="getSysInfo(1)"> 查 看 </el-button>
			</div>
			<div v-show="ifHasInfo">
				<div class="znjg-box znjg-box3">
					<div class="mt30">
						<div class="echarJg2" id="echar-jg"></div>
						<div v-for="(item,index) in sysInfo" class="gjym-boxs relative-box" :key="index">
							<p>{{pagesize*(nowPage-1)+index+1}}、{{item.name}}：{{item.msg}}</p>
							<p class="p6" v-text="dateFormat2(item.time)"></p>
						</div>
					</div>
					<div class="text-right">
				        <el-pagination
				          @current-change="handleCurrentChange"
				          :page-size="pagesize"
				          :current-page.sync="nowPage"
				          layout="total, prev, pager, next"
				          :total="totalNum">
				        </el-pagination>
				    </div>
	
				</div>
			</div>
			
			
		    <div v-if="!ifHasInfo">
				<br />
				<br />
				<br />
				<p class="errorp">筛选后无告警消息！</p>
			</div>
			
		
		

   </div>
</div>
</template>

<script>
	export default {
		mounted(){
		  	this.$nextTick(function(){
		  		if(this.administrators!=1 && this.administrators!=2){
					this.getCompanyList();
				}
		  		if(this.administrators==1 || this.administrators==2){
					this.clickCom();
				}
		  		//格式化结束时间
		  		let date = this.enddate;
				date = [
				  [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-')
				].join(' ').replace(/(?=\b\d\b)/g, '0');
				this.enddate = date;
				
				//格式化当前时间90天前
				var date2 = new Date();
				var date21 = date2.getTime() - 3600 * 1000 * 24 * 90;
				date2.setTime(date21);
				date2 = [
				  [date2.getFullYear(), date2.getMonth() + 1, date2.getDate()].join('-')
				].join(' ').replace(/(?=\b\d\b)/g, '0');
				this.startdate = date2;
				/*调用方法*/
		  		this.getSysInfo(1);
		  		this.getDevList();
		  		
		  	})
		  	
		},
		data() {
		  	return {
		  		administrators:this.getCookie('administrators'),
		  		sysInfo:[],
		  		comList:[],
		  		ifHasInfo:true,
		  		info:'',
		  		totalNum: 0,
		  		pagesize: 5,
       			nowPage: 1,
       			startdate:new Date(),
       			enddate:new Date(),
		  		dialogFormVisible:false,
		  		drawInfo:{},
		  		company_id:this.getCookie('company_id'),
		  		selectAreaId:null,
    			areaList:[],
    			selectComId:null,
    			selectCom:{},
    			alarm_type:null,
    			alarm_device_type:null,
    			typelist:[],
		  	}
		},
		methods:{
			handleCurrentChange() {
		        this.getSysInfo(-1);
		      },
			//获取告警事件
			getSysInfo(drawlineParam) {
				this.ifHasInfo = true;
				if(drawlineParam==1){
			        this.nowPage = 1;
			        			
			    }
				
				var alarm_device_type;
				if(this.alarm_device_type === null){
					alarm_device_type = -1;
				}else{
					alarm_device_type = this.alarm_device_type;
				}
				let sysInfoParams={
		  			uid:this.getCookie('uid'),
		  			company_id:this.selectComId || -1,
		  			packet_id:this.selectAreaId || -1,
		  			alarm_type:this.alarm_type || -1,
		  			alarm_device_type:alarm_device_type || -1,
		  			startdate:this.startdate,
		  			enddate:this.enddate,
		  			page:this.nowPage,
		  			pagesize:this.pagesize,
		  			token:this.getCookie('token'),
		  			time:Date.parse( new Date()),
		  			terminalId:4,
		  		};	
		  		this.sign2(sysInfoParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AlarmCount/AlarmCount",this.$qs.stringify(sysInfoParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200){
						
		        		this.drawInfo = {};
		        		if(res.data.data.totalNumber!=0){
		        			this.sysInfo = res.data.data.datalist;
							this.totalNum = res.data.data.totalNumber;
							
			        		this.drawInfo = res.data.data.statisticsResult;
			        		if(drawlineParam==1){
			        			this.drawLine();
			        		}
		        		}else{
							this.ifHasInfo = false;
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  			
		  		});
		  		
		  		
			},
//			点击选择公司
			clickCom(){
//				点击公司后MAC地址设为空
				this.mac_address = "";
//				点击公司后赋值当前选中区域为空
				this.selectAreaId = null;
				//超级管理员和普通管理员分别管理
				if(this.administrators!=1 && this.administrators!=2){
					//点击赋值当前选中公司
					for(var i=0;i<this.comList.length;i++){
						if(this.comList[i].company_id == this.selectComId){
							this.selectCom = this.comList[i];
						}
					}	
				}else{
					this.selectCom.uid = this.getCookie('uid');
				}

				let valiCodeParams={
					uid:this.selectCom.uid || -1,
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/PacketList/PacketList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 && res.data.data!=null){
		        		this.areaList = res.data.data
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			获取公司列表
			getCompanyList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		type:2,
		  			company_id:this.getCookie('company_id'),
		  			page:"1",
	  				pagesize:"9999",
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AdministratorsList/AdministratorsList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 & res.data.data!=null){
		        		if(res.data.data.name){
		        			this.comList = res.data.data.name || [];
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			获取设备类别列表
			getDevList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
			  		
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AlarmCount/AlarmDevice",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.typelist = res.data.data;
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},

			drawLine(){
				let chartJg = this.$echarts.init(document.getElementById('echar-jg'));
		    	chartJg.setOption({
					title : {
				        text: '所选范围告警图',
				        x:'left',
				        textStyle:{
				        	color:'#aaa'
				        }
				    },
				    tooltip : {
				        trigger: 'axis',
				        formatter: "告警情况 <br/>{b} : {c}（条）",
				        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
				            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
				        }
				    },
				    grid: {
				    	top:"16%",
				        left: '3%',
				        right: '4%',
				        bottom: '10%',
				        containLabel: true
				    },
				    
				    xAxis : [
				        {
				            type : 'category',
				            data : this.drawInfo.categories,
				            axisTick: {
				                alignWithLabel: true
				            },
				            axisLabel:{
				            	textStyle:{
						        	color:'#aaa'
						        }
				            },
				            axisLine: {
				                lineStyle: {
				                    color: '#aaa'
				                }
				            },
				            
				        }
				    ],
				    yAxis : [
				        {
				            type : 'value',
				            axisLine: {
				                lineStyle: {
				                    color: '#aaa'
				                }
				            },
				        }
				    ],
				    series : [
				        {
				            name:'所选区域告警统计图',
				            type:'bar',
				            barWidth: '60%',
				            itemStyle: {   
				                normal:{  
										//var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
				                    color: function (params){
				                        var colorList = ['#ff4e3c'];
				                        return colorList[params.dataIndex];
				                    }
				                }
				            },
				            data:this.drawInfo.data
				        }
				    ]
				},true);
			},
		
		}
	}
	
</script>

<style scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/alarm/alarmStatistical.vue